<template>
  <div
    v-if="feature.text || isEditMode"
    :class="{
      'price-list-item-feature-fi': true,
      'price-list-item-feature-fi--light': light,
      'price-list-item-feature-fi--checked': feature.checked,
    }"
  >
    <icon-fi
      class="price-list-item-feature-fi__icon"
      :icon="feature.checked ? 'check' : 'close'"
      size="1"
    />
    <span v-if="!isEditMode">{{ feature.text }}</span>
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-else
      v-html="feature.editable"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';

defineOptions({ name: 'PriceListItemFeatureFi' });

export interface PriceListItemFeature {
  id?: string;
  text?: string;
  checked?: boolean;
  editable?: string;
}

withDefaults(
  defineProps<{
    feature?: PriceListItemFeature;
    light?: boolean;
  }>(),
  {
    feature: () => ({}),
    light: false,
  },
);
</script>

<style scoped src="./price-list-item-feature-fi" />
